import { createFileRoute } from '@tanstack/react-router'
import { AuditorCenterCycleShell } from '@/components/auditor-center/AuditorCenterCycleShell'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId',
)({
  component: AuditorCenterCycleShell,
})
